import { Typography } from "@packages/ds";
import styled from "styled-components";

export const RefreshSectionRoot = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RefreshRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ProcessesTitle = styled(Typography.Title)`
  display: flex;
  gap: 4px;
`;
